import { useContext } from 'react'
import {
  SourcePluginContext,
  SourcePluginContextInterface,
} from './SourcePluginContextProvider'

export const useSourcePluginContext = (): SourcePluginContextInterface =>
  useContext(SourcePluginContext)
